// extracted by mini-css-extract-plugin
export default {"contributorsList":"ContributorsList_contributorsList__h7e2H","singleStory":"ContributorsList_singleStory__xzc3D"};